// extracted by css-extract-rspack-plugin
export default {"announcementTitle":"announcementTitle-ZBDciH","announcementSubTitle":"announcementSubTitle-NXFH6w","announceContent":"announceContent-KjGyNL"};